<template>
  <div class="video">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onBack">
      <template #right>
        <van-icon name="search" size="18" @click="onSearch"/>
      </template>
    </van-nav-bar>
    <van-tabs @click="getAlbum()" v-model="cid">
      <van-tab 
      v-for="(item,index) in clist" 
      :key="index"
      :title="item.title"
      :name="item.id"
      @click="setTab(index)"
      >
      <van-row class="v-list" gutter="15">
          <van-col span="12"
          v-for="(item, index) in alist" 
          :key="item.id"
          class="v-item"
          >
            <a @click="goto(index)">
            <img v-lazy="item.cover" alt="" class="v-item-img">
            <div class="v-item-desc">
              <div class="v-item-title">
                {{ item.title }}
              </div>
              <div class="v-item-date">{{ item.date }}</div>
            </div>
          </a>
        </van-col>
        </van-row>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>

export default {
  data() {
    return {
      title: '影音',
      clist: [],
      alist: [],
      cid: 0,
      activeName: 0,
      metaTitle: '影音',
    }
  },
  methods: {
    //获取欄目列表
    getCategory(id){
      this.axios.get(this.$tools.api + '/video/getcategory')
      .then(response => {
        if(response.data.code==1){
          this.clist = response.data.rows;
          if(id==null){
            this.cid = this.clist[0].id;
          }else{
            this.cid = id;
          }

          this.getAlbum();
        }
      }) 
    },
    //获取專輯列表
    getAlbum(){
      this.$router.push({ path: `/video/${this.cid}` })
      this.axios.get(this.$tools.api + '/video/getalbum?id='+this.cid )
      .then(response => {
        if(response.data.code==1){
          this.alist = response.data.rows;
        }
      }) 
      this.metaTitle = this.$tools.getCategoryTitle(this.clist, this.cid);
    },
    goto(index){
      let info = this.alist[index];
      let timestamp = Math.floor(Date.parse(new Date()) / 1000);
      this.$router.push({ path: `/player/b/${info.id}/${info.cnum}/${timestamp}` }) // -> /user/123
    },    
    //返回
    onBack(){
      this.$router.push({ path: `/` }) // -> /user/123
    },
    onSearch(){
      console.log('搜索')
      this.$router.push({ path: `/search/video` }) // -> /user/123
    },
    getImg320(url){
      return url + this.$tools.image_320;
    }
  },
  beforeDestroy() {

  },
  created() {
    this.getCategory(this.$route.params.id);
  },
  metaInfo () {
    return {
      title: this.metaTitle + '-' + this.title 
    }
  },
};
</script>
<style  scoped>

</style>